import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RushCelebrationWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    top: 0,
  },
}));

export const RushCelebrationContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, 0.5)',
}));
